import React from 'react';
import { Head } from '@inertiajs/react';
import CategoryForm from '@/components/admin/blog/CategoryForm';

interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
}

interface Props {
  category: Category;
}

const Edit: React.FC<Props> = ({ category }) => {
  return (
    <>
      <Head title={`Edit: ${category.name}`} />
      <CategoryForm category={category} isEditing={true} />
    </>
  );
};

export default Edit;
